import _ from 'lodash';

const itemIn = (root, id) => {
  const target = _.find(root?.deepProjects, { id }) || _.find(root?.deepFolders, { id });
  return target;
};

const itemsIn = (root, id) => {
  const target = itemIn(root, id);
  return _.concat(target?.deepProjects || [], target?.deepFolders || []);
};

export const collectItemsToCheck = (fullTree, id) => {
  const itemItself = { [id]: true };
  return _.reduce(itemsIn(fullTree, id), (result, item) => ({
    ...result,
    [item?.id]: true,
  }), itemItself);
};

export const collectItemsToUncheckUpstream = (fullTree, id, itemsToUncheck = {}) => {
  const itemItself = { [id]: false };
  return _.reduce(_.filter(fullTree?.allFolders, (folder) => itemIn(folder, id)), (result, item) => ({
    ...result,
    [item?.id]: false,
  }), itemItself);
};

export const collectItemsToUncheckDownstream = (fullTree, id) => {
  const itemItself = { [id]: false };
  return _.reduce(itemsIn(fullTree, id), (result, item) => ({
    ...result,
    [item?.id]: false,
  }), itemItself);
};

export const collectItemsToUncheck = (fullTree, id) => _.merge(
  collectItemsToUncheckUpstream(fullTree, id),
  collectItemsToUncheckDownstream(fullTree, id),
);
